/**
 * =========================================================================================
 * Component - Logout
 * =========================================================================================
 *
 **/

import React, {useEffect} from 'react';
import {onLogout} from '../../store/actions';

const Logout = React.memo(() => {
    useEffect(() => onLogout(), []);
    return (<></>);
});

export default Logout;
